import { track } from '../../lib/track.ts'

type EmitFn = typeof track

export type CashEmitDeps = {
  track?: EmitFn
  isProd?: () => boolean
}

function defaultIsProd(): boolean {
  return import.meta.env.PROD === true
}

/** Prod-only. Props are ids / kinds only — never amounts or names. */
export function emitCash(
  event: string,
  props?: Record<string, string | number | boolean | null | undefined>,
  deps: CashEmitDeps = {},
): void {
  const isProd = deps.isProd || defaultIsProd
  if (!isProd()) return
  const send = deps.track || track
  send(event, props)
}
